import React from 'react';
import {InputBase, Typography} from "@mui/material";
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";

const InputOtp = ({
    placeholder, 
    sx, 
    inputLabel,
    size,
    rightIcon,
    leftIcon,
    sxIcon,
    type,
    value,
    onChange,
    key,
    maxLength,
    onKeyDown,
    ref
}) => {
    
    return (
        <Div sx={{
            ...sx
        }}>
            <InputBase 
                placeholder={placeholder} 
                fullWidth
                size={size}
                type={type}
                value={value}
                onChange={onChange}
                key={key}
                maxLength={maxLength}
                onKeyDown={onKeyDown}
                ref={ref}
                sx={{
                    color: 'inherit',
                    display: 'flex',
                    borderRadius: '8px',

                    '& .MuiInputBase-input': {
                        padding: theme => theme.spacing(1, 1, 1, 1),
                        textAlign: 'center',
                        maxHeight: '40px',
                        border: "1px solid #ADADAD",
                        borderRadius: 2,
                        fontSize: 16,
                        fontWeight: 700,
                        margin: '0 8px',
                        backgroundColor: '#ffffff',
                    },

                    '&.Mui-focused .MuiInputBase-input': {
                        border: "1px solid #4285F4",
                    },
                }}
            />
        </Div>
    );
};

export default InputOtp;
